type NumberFormattingOptions = {
    /** Locale preference (e.g. `fr-fr`, `en-au`) used by Intl.NumberFormat. */
    localePreference?: string;
    /** Upper bound on fraction digits to display. */
    maximumFractionDigits?: number;
    /** Lower bound on fraction digits to display (pads trailing zeros when needed). */
    minimumFractionDigits?: number;
    /** Whether to include grouping separators (e.g. `1,000` vs `1000`). */
    useGrouping?: boolean;
};

/**
 * Formats a number using locale-aware separators via Intl.NumberFormat.
 */
export const formatLocalizedNumber = (
    value: number,
    { localePreference, maximumFractionDigits, minimumFractionDigits, useGrouping = false }: NumberFormattingOptions,
): string => {
    const numberFormatOptions: Intl.NumberFormatOptions = {
        maximumFractionDigits,
        minimumFractionDigits,
        useGrouping,
    };

    return new Intl.NumberFormat(localePreference, numberFormatOptions).format(value);
};
